import React, { useContext } from 'react'
import Alert from 'react-bootstrap/Alert'
import { AlertContext } from '../context/alert'

const NotificationBar = () => {
    const { notification, notificationText } = useContext(AlertContext);

    const handleCloseClick = () => {
        // setShow(false)
    }

    return (
        notification !== null && (
                <Alert show={notification} variant={notification} dismissible={true} onClose={handleCloseClick}>
                    {notificationText}
                </Alert>
            )
    )
};

export default NotificationBar